export default __webpack_public_path__ + "static/media/haj3.b43f4ae1.jpg";